module.exports = __webpack_public_path__ + "static/img/profile_city.435c148.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile_city.jpg
// module id = TMoe
// module chunks = 1